export { SERVICE_URLS_PROD } from './service-urls-prod'
export { SERVICE_URLS_DEV } from './service-urls-dev'
export {
  SERVICE_URLS_RECORD_MAP,
  type ServiceUrls,
  type IServiceUrls,
} from './service-urls.types'
